import { CENTRAL_DOACOES_PERMISSIONS } from "constants/index";
import { saveAs } from "file-saver";
import React, { Component } from "react";
import WidgetModalForm, {
	ModalFormContext
} from "../../../components/Modal/modalForm.component";
import Table from "../../../components/Table/table.component";
import downloadService from "../../../services/downloadService";
import { formatarTelefone } from "../../../utils/telefoneHelper";

export default class VisualizaOficio extends Component {
	constructor(props) {
		super(props);
		this.state = {
			documentos: []
		};
		this.columns = [];
		this.actions = [];
	}

	componentWillMount() {
		this.columns = [{ id: 0, title: "Anexo", property: "nome" }];

		this.actions = [
			{
				id: 0,
				name: "Download do arquivo",
				icon: "fas fa-download",
				action: item => this.downloadFile(item)
			}
		];
		const { oficio } = this.props;
		this.setState({ documentos: [oficio.documento] });
	}

	downloadFile = async documento => {
		const { data: arquivo } = await downloadService.download(documento);
		const blob = new Blob([arquivo]);
		saveAs(blob, documento.nome);
	};

	render() {
		const {
			props: { isOpenVisualizar, handleCloseVisualizar, oficio },
			state: { documentos }
		} = this;

		return (
			<WidgetModalForm
				initialValues={oficio}
				iconCancelar="fas fa-times"
				textCancelar="Fechar"
				title="Visualizar ofício"
				isOpen={isOpenVisualizar}
				cancelar={handleCloseVisualizar}
				tamanho="lg"
			>
				<ModalFormContext.Consumer>
					{({ values }) => (
						<React.Fragment>
							<div className="row">
								<div className="col-md-12 pl-0 pr-0">
									{values.municipio !== null && (
										<React.Fragment>
											<div className="col-12">
												<strong>Município:</strong>
												<p>{values.municipio.nome}</p>
											</div>
											<div className="d-flex">
												<div className="col-6">
													<strong>
														Data de recebimento:
													</strong>
													<p>
														{values.dataRecebimento}
													</p>
												</div>
												<div className="col-6">
													<strong>Status:</strong>
													<p>{values.status.nome}</p>
												</div>
											</div>{" "}
											{/* d-flex */}
										</React.Fragment>
									)}

									{values.entidade !== null && (
										<React.Fragment>
											<div className="col-12">
												<strong>Entidade:</strong>
												<p>{values.entidade.nome}</p>
											</div>
											<div className="d-flex">
												<div className="d-flex flex-column col-6">
													<div>
														<strong>CNPJ:</strong>
														<p>
															{
																values.entidade
																	.cnpj
															}
														</p>
													</div>
													<div>
														<strong>CEP:</strong>
														<p>
															{
																values.entidade
																	.endereco
																	.cep
															}
														</p>
													</div>
													<div>
														<strong>
															Logradouro:
														</strong>
														<p>
															{
																values.entidade
																	.endereco
																	.logradouro
															}
														</p>
													</div>
													<div>
														<strong>Número:</strong>
														<p>
															{
																values.entidade
																	.endereco
																	.numero
															}
														</p>
													</div>
													<div>
														<strong>
															Data de recebimento:
														</strong>
														<p>
															{
																values.dataRecebimento
															}
														</p>
													</div>
												</div>{" "}
												{/* d-flex flex-column col-6 */}
												<div className="d-flex flex-column col-6">
													<div>
														<strong>
															Telefone principal:
														</strong>
														<p>
															{formatarTelefone(
																values.entidade
																	.telefonePrincipal
															)}
														</p>
													</div>
													<div>
														<strong>
															Município:
														</strong>
														<p>
															{
																values.entidade
																	.endereco
																	.municipio
																	.nome
															}
														</p>
													</div>
													<div>
														<strong>Bairro:</strong>
														<p>
															{
																values.entidade
																	.endereco
																	.bairro
															}
														</p>
													</div>
													<div>
														<strong>
															Complemento:
														</strong>
														<p>
															{values.entidade
																.endereco
																.complemento
																? values
																		.entidade
																		.endereco
																		.complemento
																: "--"}
														</p>
													</div>
													<div>
														<strong>Status:</strong>
														<p>
															{values.status.nome}
														</p>
													</div>
												</div>{" "}
												{/* d-flex flex-column col-6 */}
											</div>{" "}
											{/* d-flex */}
										</React.Fragment>
									)}

									<div>
										<Table
											isPageNumber={false}
											acoesSingleButton
											className="text-left"
											columns={this.columns}
											actions={this.actions}
											data={documentos}
											emptyMessage="Não há registros cadastrados."
											emptyColSpan={
												this.columns.length + 1
											}
											showPaginate={false}
											maxCharactersShown={75}
											permission={
												CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR
											}
										/>
									</div>
								</div>{" "}
								{/* col-md-12 pl-0 pr-0 */}
							</div>{" "}
							{/* .row */}
						</React.Fragment>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
